import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ExclamationCircleIcon } from '@heroicons/react/24/outline';
import Button from '../../../components/ui/Button';
import Card, { CardContent } from '../../../components/ui/Card';
import { initiateOnboarding } from '../../../services/stripeConnectService';

const StripeConnectRefresh: React.FC = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleRetry = async () => {
    setLoading(true);
    setError(null);
    try {
      const onboardingUrl = await initiateOnboarding();
      window.location.href = onboardingUrl;
    } catch (err: any) {
      console.error('Failed to restart onboarding:', err);
      setError(err.response?.data?.message || 'Failed to restart the onboarding process. Please try again.');
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <Card className="max-w-md w-full">
        <CardContent className="p-8 text-center">
          <ExclamationCircleIcon className="w-16 h-16 text-yellow-600 mx-auto mb-4" />
          <h2 className="text-xl font-semibold text-gray-900 mb-2">
            Stripe Connect Setup Interrupted
          </h2>
          <p className="text-gray-600 mb-6">
            The onboarding process was interrupted or the link expired. 
            You can restart the process or return to the payouts page.
          </p>

          {error && (
            <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg">
              <p className="text-sm text-red-700">{error}</p>
            </div>
          )}

          <div className="space-y-3">
            <Button 
              onClick={handleRetry} 
              disabled={loading} 
              className="w-full"
            >
              {loading ? 'Loading...' : 'Restart Onboarding'}
            </Button>
            <Button 
              onClick={() => navigate('/dashboard/payouts')} 
              variant="secondary" 
              className="w-full"
            >
              Back to Payouts
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default StripeConnectRefresh;
